module.exports = __webpack_public_path__ + "img/12.c2f3406c.png";